import { render } from "./TardyDetentionsAndAppointments.vue?vue&type=template&id=8b321882"
import script from "./TardyDetentionsAndAppointments.vue?vue&type=script&lang=js"
export * from "./TardyDetentionsAndAppointments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__